import { AlertCircle, RefreshCw } from "lucide-react";

interface ErrorStepProps {
  error: string;
  onRetry: () => void;
  onBack: () => void;
}

export function ErrorStep({ error, onRetry, onBack }: ErrorStepProps) {
  return (
    <div className="p-12 text-center">
      <div
        className="inline-flex items-center justify-center w-16 h-16 rounded-full mb-6"
        style={{ backgroundColor: "rgba(217, 48, 37, 0.1)" }}
      >
        <AlertCircle
          className="w-8 h-8"
          style={{ color: "var(--danger-color)" }}
        />
      </div>
      <h3
        className="text-xl font-bold mb-3"
        style={{ color: "var(--text-primary)" }}
      >
        Erro ao Gerar Aula
      </h3>
      <p
        className="text-sm mb-6 max-w-md mx-auto"
        style={{ color: "var(--text-tertiary)" }}
      >
        {error}
      </p>
      <div className="flex gap-3 justify-center">
        <button
          onClick={onRetry}
          className="flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition hover:shadow-md"
          style={{
            backgroundColor: "var(--bg-accent)",
            color: "var(--primary-color)",
          }}
        >
          <RefreshCw className="w-4 h-4" />
          Tentar Novamente
        </button>

        <button
          onClick={onBack}
          className="flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition hover:shadow-md"
          style={{ backgroundColor: "#f1f3f4", color: "#5f6368" }}
        >
          Voltar ao Formulário
        </button>
      </div>
    </div>
  );
}
